export default __webpack_public_path__ + "static/media/bisaroPhoto.5548fa63.jpeg";